import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoiceDashboardListItem } from "@msuite/utils/types";
import { formatInvoiceAmount, formatInvoiceDate } from "@/components/incoming-invoices";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<IncomingInvoiceDashboardListItem>();

export const columns = [
	columnHelper.accessor("supplier", {
		id: "supplier",
		header: localized("incoming_invoices.supplier"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("number", {
		id: "number",
		header: localized("incoming_invoices.number"),
		cell: (cell) => guardString(cell.getValue()),
		size: 180,
	}),
	columnHelper.accessor("dueDate", {
		id: "dueDate",
		header: localized("incoming_invoices.due_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 160,
	}),
	columnHelper.accessor("grossAmount", {
		id: "grossAmount",
		header: localized("incoming_invoices.gross_amount"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), cell.row.original.currency),
		size: 130,
	}),
	createRowActions(RowActions),
];
